import React, { useState, useRef, useEffect } from "react";
import FilterDropdown from "./FilterDropdown";
import { MdSearch } from "react-icons/md";

const FilterCard = ({
  tempFilters,
  setTempFilters,
  onFilterChange,
  fields = [],
}) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRefs = useRef({});

  const handleChange = (key, value) => {
    const updatedFilters = { ...tempFilters, [key]: value };
    setTempFilters(updatedFilters);
    onFilterChange?.(updatedFilters);
    setOpenDropdown(null); // close dropdown after select
  };

  //  Custom outside click handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openDropdown &&
        dropdownRefs.current[openDropdown] &&
        !dropdownRefs.current[openDropdown].contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdown]);

  return (
    <div className="bg-white w-full rounded-2xl shadow-md border px-4 py-3">
      <div className="flex flex-wrap gap-2">
        {fields.map((field) => {
          const value = tempFilters[field.key] || "";

          return (
            <div key={field.key} className="flex flex-col min-w-[120px]">
              {field.type === "select" ? (
                <FilterDropdown
                  ref={(el) => (dropdownRefs.current[field.key] = el)}
                  label={field.label}
                  options={field.options || []}
                  value={value}
                  isOpen={openDropdown === field.key}
                  onToggle={() =>
                    setOpenDropdown(
                      openDropdown === field.key ? null : field.key
                    )
                  }
                  onChange={(val) => handleChange(field.key, val)}
                />
              ) : field.type === "date" ? (
                <label className="flex items-center gap-2 pl-2">
                  <span
                    className="text-base text-gray-700 text-bold
                  "
                  >
                    {field.label}
                  </span>
                  <input
                    type="date"
                    value={value}
                    onChange={(e) => handleChange(field.key, e.target.value)}
                    className="border border-gray-300 rounded-lg text-sm focus:ring-1 py-1 px-2 focus:ring-blue-500 focus:outline-none"
                  />
                </label>
              ) : field.type === "search" ? (
                <div className="relative flex items-center w-full md:w-[300px] lg:w-[400px]">
                  <MdSearch
                    size={20}
                    className="absolute left-3 text-gray-500"
                  />

                  <input
                    type="text"
                    name="search"
                    value={tempFilters.search}
                    onChange={(e) => handleChange(field.key, e.target.value)}
                    placeholder={field.placeholder}
                    className="w-full rounded-lg border border-gray-300 bg-white text-sm pl-9 pr-8
                  placeholder-gray-400 focus:ring-1 focus:border-blue-500 outline-none transition duration-150"
                  />

                  {tempFilters.search && (
                    <button
                      type="button"
                      onClick={(e) => handleChange(field.key, "")}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      ✕
                    </button>
                  )}
                </div>
              ) : (
                <input
                  type="text"
                  value={value}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                  placeholder={`Enter ${field.label}`}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FilterCard;
